exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.pagination>li {\n  display: inline-block!important;\n  margin-right: -4px;\n}\n.page-item:first-child .page-link,\n.page-item:last-child .page-link{\n  border-radius: 0px;\n  cursor: pointer;\n}\n.pagination > li.disabled {\n   cursor: not-allowed;\n}\n.pagination > li.disabled> a,.pagination > li.disabled> span {\n  pointer-events: none;\n}\n.pagination > li.disabled .page-link{\n  color: #908b8b!important;\n}\n\n", ""]);

// exports
